// TODO ADD MULTIPLE VARIANT SEPARATELY
import type { IChipValueType } from "@components/atoms/chip/types";

export const colors: Record<IChipValueType | "default", string> = {
  yes: "#61D215",
  no: "#E32322",
  nodata: "#f59e0b",
  noRole: "#f59e0b",
  default: "#D0288D",
  faculty_Member: "#0C6291",
  staff: "#564766",
  super_admin: "#CCA829",
  unknown: "#F74B4A",
  active: "#61D215",
  inactive: "#F74B4A",
  PG: "#8693AB",
  UG: "#295DE1",
  departmentStaff: "#4E670F",
};
